// extracted by mini-css-extract-plugin
export default {"basketTrigger":"styles__basketTrigger___zLLWI","active":"styles__active___wiFvA"};